import { styled } from '@linaria/react'
import { ReactNode } from 'react';
import theme from '../theme';

const PanelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
    background-color: ${theme.color.blue.selected};
    width: 20vw;
    height: 100vh;
    box-shadow: 0 0 3px 1px ${theme.color.blue.primary};1A; // alpha 10%
    overflow: auto;
    box-sizing: border-box;
`;

const PanelTitle = styled.div`
    padding: 16px;
    background-color: ${theme.color.blue.light};
`;

interface PanelProps {
    title?: ReactNode;
    children: ReactNode;
}

const Panel = ({ children, title }: PanelProps) => (
    <PanelWrapper>
        {title ? <PanelTitle>{title}</PanelTitle> : null}
        {children}
    </PanelWrapper>
);

export default Panel;
